
<template>
  <Control :title="title" :isEdit="isEdit && enabled" :validator="validator" :provider="editor ? editor.owner:null"  :isDirectEditEnabled="isDirectEditEnabled"  :editor="editor"  :enabled="enabled"  :tooltip="tooltip"  :key="title"  :required="required" :keyfield="keyfield">
    <template slot="read">{{selectedText}}</template>
    <template slot="edit">
      <b-form-select ref="target" :class="{'is-invalid': validator.isInvalid}" v-model="selected" :options="options2()" class="mb-3" size="sm"/>
      <!-- 新規追加用ダイアログ -->
      <b-modal class="dialog" v-model="showDialog" v-if="showDialog" title="注意事項" :ok-only='true' :no-close-on-backdrop="true" centered>
        <span>{{alertMessage}}</span>
      </b-modal>          
    </template>
  </Control>
</template>
<script lang="ts">

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';
import { defineLocale } from 'moment';

@Component
export default class ComboBox extends Vue implements Components.IControl {

  @Prop({ default: '' }) public title?: string;
  @Prop({ default: null }) public value?: any;
  @Prop({ default: '' }) public list?: string;
  @Prop({default:null}) public provider: () => Common.BindItem[];
  @Prop({ default: false }) public required: boolean;
  @Prop({default:false}) public keyfield: boolean;      
  @Prop({ default: null }) public nullValue: any;
  @Prop({ default: true }) public showDefault: boolean;  
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;
  @Prop() public tooltip: string;
  @Prop() public alertValues: number[];  
  @Prop() public alertMessage: string;
  
  public isEdit: boolean = true;
  public isMounted:boolean = false;
  public validator: Components.ControlValidator;
  public showDialog:boolean = false;

  created() {
    this.validator = new Components.ControlValidator(this, 'tooltip', this.internalValidate);
    if (this.editor != null) this.editor.addControl(this);
    //単独ロードもしくはlistViewによるリロード待ち
    if (this.list) this.$api.formatter.ensureListLoaded(this.list).then(()=>this.$forceUpdate()); 
  }
  @Watch('value')
  public onValueChanged(){
    if (this.isMounted && this.alertMessage && this.alertValues.includes(this.value)) this.showDialog=true;
    else this.showDialog=false;
  }
  
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }
  mounted(){
    this.isMounted = true;
  }

  public internalValidate(): string {

    const value = this.selected;
    //value==''はvalue:=falseに対してtrueになるので除外
    // if (this.required && value != false && (value == '' || value == null)) {
    if (this.required && value == this.nullValue) {      
      return '必須項目です';
    }

    return '';
  }

  @Watch('value')
  public onValueChange() {
    this.validator.update();
  }

  public get selected(): any {
    return this.value;
  }

  public set selected(value: any) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value);
    this.$emit('changed');

  }

  public get selectedText(): string {
    for (const option of this.options2(false)) {
      if (option.value === this.value) {
        return option.text;
      }
    }
    //リストに初期値がない場合の対応
    if (this.value == this.nullValue) return '(未選択)';
    
    return '';
  }
  public options2(replaceDefault:boolean = true): any {
    const results: any[] = new Array();
    if (this.showDefault) results.push({ text: '', value: this.nullValue });
    if (this.provider){
      this.provider().forEach(element => {
        //選択肢では初期値はブランク表示に変換する
        if (replaceDefault && element.value == this.nullValue) results.push({ text: '', value: this.nullValue });
        else results.push(element);
      });
    } else {
      for (const option of this.$api.formatter.getOptions(this.list)) {
        //選択肢では初期値はブランク表示に変換する        
        if (replaceDefault && option.value == this.nullValue) results.push({ text: '', value: this.nullValue });
        else results.push({ text: option.text, value: option.value });
      }
    }

    return results;
  }
}
</script>
<style>
.custom-select.is-invalid {
  /* ×ボタンとプルダウンボタンの位置を調整 */
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
      no-repeat right 2rem center/8px 10px,
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E")
      #fff no-repeat center right 0.5rem / calc(0.75em + 0.375rem)
      calc(0.75em + 0.375rem);
}
</style>